<template>
    <ion-page>
        <ion-header>
            <ion-toolbar>
                <ion-buttons slot="end">
                    <ion-button @click="close()">
                        <ion-icon slot="icon-only" :icon="closeOutline"></ion-icon>
                    </ion-button>
                </ion-buttons>
                <ion-title>Take a Photo</ion-title>
            </ion-toolbar>
        </ion-header>
        <ion-content>
            <ion-card>
                <ion-card-content class="ion-justify-content-center ion-align-items-center" style="min-height: 300px">
                    <ion-img v-if="blob && blob.length > 0" :src="'data:image/png;base64,' + blob" />
                </ion-card-content>
            </ion-card>

        </ion-content>
        <ion-footer>
            <ion-row>
                <ion-col>
                    <ion-button expand="block" color="primary" @click="capture()">Take Picture</ion-button>
                </ion-col>
                <ion-col>
                    <ion-button expand="block" color="success" @click="accept()" :disabled="(!blob || blob.length < 1)">Accept Photo</ion-button>
                </ion-col>
            </ion-row>
        </ion-footer>
    </ion-page>

</template>

<script>
import {
    IonHeader,
    IonToolbar,
    IonButtons,
    IonButton,
    IonTitle,
    IonContent,
    IonPage,
    IonImg,
    IonIcon,
    modalController,
    IonFooter,
    IonCard,
    IonCardContent,
    IonRow,
    IonCol
} from "@ionic/vue";
import {checkmarkCircle, search, barcode, listOutline, closeOutline} from 'ionicons/icons';
import { Camera, CameraResultType } from '@capacitor/camera';
export default {
    name: "GoodsIn",
    inject: ['$http', '$toast', '$validationAlert', '$scanner'],
    components: {
        IonContent, IonPage,
        IonButton, IonTitle,
        IonButtons, IonToolbar,
        IonHeader, IonImg,
        IonFooter, IonIcon,
        IonCard,
        IonCardContent,
        IonRow,
        IonCol
    },
    methods: {
        accept() {
            modalController.dismiss(this.blob);
        },
        close() {
            modalController.dismiss();
        },
        capture() {
            Camera.getPhoto({
                resultType: CameraResultType.Base64,
                width: 256,
                height: 256,
                preserveAspectRatio: true
            }).then(response => {
                this.blob = response.base64String;
            });
        }
    },
    data() {
        return {
            blob: null,
        }
    },
    setup() {
        return {
            checkmarkCircle, search, barcode, listOutline, closeOutline
        }
    }

}
</script>
<style scoped>
</style>
